import React, { ReactNode } from 'react';
import { EmptyStateBaseProps } from './EmptyStateBase';
import { useMultiCollectionSupportContext } from '../MultiCollectionSupportProvider';
import { ToolbarCollectionEmptyStateBasePrivate } from './ToolbarCollectionEmptyStateBasePrivate';
import { NewItemButtonProps } from './NewItemButton';

export interface ToolbarCollectionEmptyStateBaseProps
  extends Omit<Partial<EmptyStateBaseProps>, 'cta'>,
    NewItemButtonProps {
  children?: ReactNode;
}

export function ToolbarCollectionEmptyStateBase(
  props: ToolbarCollectionEmptyStateBaseProps,
) {
  const state = useMultiCollectionSupportContext();
  return <ToolbarCollectionEmptyStateBasePrivate {...props} state={state} />;
}
